import styled from 'styled-components'

const ManageInvitationsWrapper = styled.div`
 /* max-height: calc(100vh - 405px);
    overflow: auto; */
`
const InvitationsRow = styled.div`
  /* min-height: 63px; */
  border-bottom: solid 1px #c9c9c9;
  display: grid;
  grid-template-columns: 1fr auto;
  padding: 20px 40px;
  align-items: center;
  grid-gap: 15px;
  h3 {
    font-size: 17px;
    font-family: "latobold";
  }
  .action-btn {
    display: flex;
    gap: 34px;
    .active {
      height: 40px;
      width: 98px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      color: #fff;
      background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
      border: none;
      border-radius: 5px;
    }
    .pending {
      background-color: #868d91 !important;
      height: 40px;
      width: 98px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      color: #fff;     
      border: none;
      border-radius: 5px;
      cursor: default;
    }
  }
  @media (max-width: 650px) {
    padding: 15px 40px;
    grid-template-columns: 1fr;
    h3 {
      font-size: 15px;
    }
    .action-btn {
      gap: 20px;
    }
  }
  
`;

export { ManageInvitationsWrapper, InvitationsRow }